<cc-instagram-story-container *ngIf="displayInstaStories" [storyData]="storyDataModel" [config]="config"> </cc-instagram-story-container>
